import { useSelector } from 'react-redux';
import { SmallProduct } from '../../Product';
import { LoaderIcon } from '../../../../utils/svg';
import { useMemo } from 'react';
import { isEmptyData } from '../../../../utils/helper';
import useProduct from '../../../hook/useProduct';

const Menu = (props) => {
	const { gps } = props;
	const { isLoading, products, keyword, selectedCategory } = useProduct();

	const filteredProduct = useMemo(() => {
		if (!products?.length) return [];

		let result = products;

		if (isEmptyData(keyword)) {
			result = result.filter((p) => p?.product_recommendation !== 'Yes');
		}

		if (isEmptyData(keyword) && selectedCategory && selectedCategory !== 'all') {
			result = result.filter((product) => selectedCategory === product?.pro_cate_slug);
		}

		if (!isEmptyData(keyword)) {
			const lowerKeyword = keyword.toLowerCase();
			result = result.filter((product) => product?.product_name?.toLowerCase().includes(lowerKeyword));
		}

    return result;
	}, [products, selectedCategory, keyword]);

  return (
		<div className={`h-full ${!filteredProduct?.length && !isLoading && 'hidden'}`}>
			{isLoading ? (
				<div className='w-full h-16 flex justify-center items-center'>
					<LoaderIcon />
				</div>
			) : (
				<>
					<div className={`text-gray-700 font-semibold text-base ${!isEmptyData(keyword) && 'hidden'}`}>Makanan</div>
					<div className='mt-4 flex flex-col gap-4'>
						{filteredProduct?.map((product, index) => {
							return <SmallProduct key={index} {...{ product, gps }} />;
						})}
					</div>
				</>
			)}
		</div>
	);
};

export default Menu;
